import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

export const Label = styled.div`
  color: #7f7f7f;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
`;

export const FieldWrapper = styled.div`
  width: 100%;
  margin-bottom: 32px;
  input::placeholder {
    font-weight: 300;
  }
`;

export const SwitchWrapper = styled.div`
  padding: 8px 0;
  margin-bottom: 32px;
`;

export const Button = styled(ButtonAntD)`
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary) {
    &:hover,
    &:focus,
    &:active {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const MessageBox = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;
